export type VehicleTypeKey = 'cng' | 'auto' | 'motorcycle';

export interface VehicleTypeConfig {
  key: VehicleTypeKey;
  label: string;
  short: string;
  en: string;
  qrPrefix: string;
  regSample: string;
  regHint: string;
  engineLabel: string;
  authority: string;
  driverLabel: string;
  documents: string[];
}

export const vehicleTypes: VehicleTypeConfig[] = [
  {
    key: 'cng',
    label: 'সিএনজি অটোরিকশা',
    short: 'সিএনজি',
    en: 'CNG Auto-rickshaw',
    qrPrefix: 'CNG-',
    regSample: 'ঢাকা-থ-১৬-০৪৭২',
    regHint: 'ফরম্যাট: ঢাকা-থ-XX-XXXX',
    engineLabel: 'ইঞ্জিন নং',
    authority: 'BRTA',
    driverLabel: 'অনুমোদিত চালক',
    documents: ['রেজিস্ট্রেশন সনদ (ব্লু-বুক)', 'ফিটনেস সনদ', 'ট্যাক্স টোকেন', 'রুট পারমিট', 'সিলিন্ডার পরীক্ষার সনদ', 'মালিকের NID', 'গাড়ির ছবি']
  },
  {
    key: 'auto',
    label: 'ব্যাটারিচালিত অটোরিকশা',
    short: 'অটোরিকশা',
    en: 'Battery Auto-rickshaw',
    qrPrefix: 'ATR-',
    regSample: 'ঢাউসিক-অটো-০৮-৪৫২১',
    regHint: 'সিটি কর্পোরেশন লাইসেন্স / নিবন্ধন নম্বর',
    engineLabel: 'মোটর নং',
    authority: 'সিটি কর্পোরেশন',
    driverLabel: 'অনুমোদিত চালক',
    documents: ['সিটি কর্পোরেশন লাইসেন্স', 'চলাচল এলাকার অনুমতিপত্র', 'ব্যাটারি/মোটর ক্রয় রসিদ', 'মালিকের NID', 'গাড়ির ছবি']
  },
  {
    key: 'motorcycle',
    label: 'মোটরসাইকেল',
    short: 'মোটরসাইকেল',
    en: 'Motorcycle',
    qrPrefix: 'MCL-',
    regSample: 'ঢাকা মেট্রো-হ-৩৪-৫৬৭৮',
    regHint: 'ফরম্যাট: ঢাকা মেট্রো-হ-XX-XXXX',
    engineLabel: 'ইঞ্জিন নং',
    authority: 'BRTA',
    driverLabel: 'অনুমোদিত চালক / রাইডার',
    documents: ['রেজিস্ট্রেশন সনদ (ডিজিটাল কার্ড)', 'ট্যাক্স টোকেন', 'বীমা সনদ', 'মালিকের NID', 'গাড়ির ছবি']
  }
];

export function vehicleTypeByLabel(label: string): VehicleTypeConfig {
  return vehicleTypes.find((v) => v.label === label) ?? vehicleTypes[0];
}

export const vehicleTypeStats = [
  { key: 'cng', label: 'সিএনজি অটোরিকশা', approx: 'প্রায় ১৭,০০০', total: 17000, verified: 16200, pending: 500, issues: 300, stickers: 15850 },
  { key: 'auto', label: 'ব্যাটারিচালিত অটোরিকশা', approx: '৩–৭ লক্ষ (আনুমানিক)', total: 350000, verified: 212400, pending: 98600, issues: 39000, stickers: 198300 },
  { key: 'motorcycle', label: 'মোটরসাইকেল', approx: 'প্রায় ১ লক্ষ', total: 100000, verified: 71800, pending: 21500, issues: 6700, stickers: 68400 }
];
